
import React from 'react';
import { ArrowRight, ShieldCheck, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PaintWaveAnimation from './PaintWaveAnimation';

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-gradient-to-b from-frikopplad-cream to-white">
      <div className="container-custom section flex flex-col md:flex-row items-center">
        <div className="w-full md:w-1/2 space-y-6 mb-10 md:mb-0 z-10">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-frikopplad-navy leading-tight"
              dangerouslySetInnerHTML={{ __html: t('home.hero.title') }}>
          </h1>
          <p className="text-lg md:text-xl text-frikopplad-navy opacity-90">
            {t('home.hero.description')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 pt-4">
            <Link to="/paket" className="btn-primary flex items-center justify-center">
              {t('home.hero.discoverButton')}
              <ArrowRight size={18} className="ml-2" />
            </Link>
            <Link to="/varfor" className="btn-outline flex items-center justify-center">
              {t('home.hero.whyButton')}
            </Link>
          </div>
        </div>
        <div className="w-full md:w-1/2 md:pl-4 lg:pl-6 flex justify-center">
          <div className="relative w-full max-w-xl">
            <div className="absolute -top-8 -left-8 w-64 h-64 bg-frikopplad-blue/10 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-12 -right-8 w-64 h-64 bg-frikopplad-red/10 rounded-full blur-3xl"></div>
            <PaintWaveAnimation />
          </div>
        </div>
      </div>
      
      <div className="container-custom py-8 pb-16">
        <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm">
          <p className="text-center text-gray-700">
            {t('home.quote')}
          </p>
          <div className="mt-4 flex flex-wrap justify-center gap-4 items-center">
            <ShieldCheck className="h-5 w-5 text-frikopplad-burgundy" />
            <span className="text-frikopplad-navy font-medium">{t('home.values.stability')}</span>
            <Globe className="h-5 w-5 text-frikopplad-blue ml-2" />
            <span className="text-frikopplad-navy font-medium">{t('home.values.transparency')}</span>
            <ShieldCheck className="h-5 w-5 text-frikopplad-burgundy ml-2" />
            <span className="text-frikopplad-navy font-medium">{t('home.values.control')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
